module.exports = __webpack_public_path__ + "static/ibarra-radio-237a8508be446daa47a999aa5a01338b.png";